const state = {
  Countries: [],
  StateProvinces: [],
  LookupEnums: {},
  TaskTypes: {}
};

const getters = {
  StateProvinces: function(state) {
    return state.StateProvinces || [];
  },
  Countries: function(state) {
    return state.Countries || [];
  },
  CrmLeadTypes: function(state) {
    if (
      state.LookupEnums &&
      state.LookupEnums.crm_lead_type &&
      state.LookupEnums.crm_lead_type.length > 0
    ) {
      return state.LookupEnums.crm_lead_type;
    }
    return [];
  }
};

const actions = {
  async getCountries(context) {
    const response = await context.getters.CxmApiClient.ProcessRequest(
      "get",
      "/crm/Lookup/countries"
    );

    if (response && response.data && response.data.successful)
      context.commit("setCountries", response.data.data);
  },
  async getStateProvinces(context, countryid) {
    const response = await context.getters.CxmApiClient.ProcessRequest(
      "get",
      "/crm/Lookup/countries/" + countryid + "/state_provinces"
    );
    if (response && response.data.successful)
      context.commit("setStateProvinces", response.data.data);
  },
  getLookupEnums(context) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest("get", "/crm/Lookup/enums")
        .then(response => {
          if (response && response.data.successful) {
            context.commit("setEnums", response.data.data);
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  getTaskTypes(context) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "get",
        "/crm/Lookup/tasktypes"
      )
        .then(response => {
          if (response && response.data.successful) {
            context.commit("setTaskTypes", response.data.data);
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  async getContactCulture(context, platformId) {
    let response = await context.getters.CxmApiClient.ProcessRequest(
      "GET",
      "/crm/Lookup/contact_culture",
      null,
      platformId ? [platformId] : []
    );
    return response && response.data ? response.data : null;
  }
};

const mutations = {
  setCountries(state, val) {
    state.Countries = val;
  },
  setStateProvinces(state, val) {
    state.StateProvinces = state.StateProvinces.concat(val);
  },

  setEnums(state, val) {
    if (val && val.crm_lead_type && val.crm_lead_type.length > 0) {
      let types = val.crm_lead_type;
      let categories = val.crm_lead_category;
      types.forEach(type => {
        let category = categories.find(x => x.id == type.crmLeadCategoryId);
        type.name = category
          ? type.name + " (" + category.name + ")"
          : type.name;
      });
    }
    state.LookupEnums = val;
  },
  setTaskTypes(state, val) {
    state.TaskTypes = val;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/LookUp.js